import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button from "src/components/Button";
import Loader from "src/components/Loader";
import Field from "src/components/field/Field";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useUsers from "src/hooks/api/services/users/useUsers";
import useModal from "src/hooks/useModal";
import useQueryString from "src/hooks/useQueryString";

const EditUserModal = ({ t }: Translation) => {
	const modal = useModal();
	const { id } = useParams();
	const qs = useQueryString();
	const { users, status, actions } = useUsers();
	const user = users.find((item) => item.hid === id);
	const [form, setForm] = useState({
		teams: user?.teams || [],
	});

	useEffect(() => {
		if (user?.id) {
			modal.setTitle(user.full_name);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onSubmit = async (e?: any) => {
		if (e) e.preventDefault();

		await actions.update(
			{
				id,
				...form,
			},
			{
				updateList: true,
			}
		);
		modal.onClose();
	};

	const onDelete = async (e?: any) => {
		if (e) e.preventDefault();
		if (id) {
			await actions.delete(id);
			modal.onClose();
		}
	};

	if (status === "loading") {
		return (
			<div className="flex justify-center items-center p-4">
				<Loader />
			</div>
		);
	}

	if (!user?.id) {
		return (
			<div className="flex flex-col gap-2">
				<strong>{t("not-found.title")}</strong>
			</div>
		);
	}

	if (qs.type === "delete") {
		return (
			<div className="">
				<Button
					onClick={onDelete}
					disabled={status !== "idle"}
					loading={status !== "idle"}
					className="w-full"
					type="red"
				>
					{t("buttons.delete")}
				</Button>
			</div>
		);
	}

	return (
		<form {...{ onSubmit }} className=" ">
			<Field.Team
				wrapper={{
					label: t("fields.team.label"),
					layout: "horizontal",
				}}
				value={form.teams}
				onChange={(teams) =>
					setForm((state: any) => ({
						...state,
						teams,
					}))
				}
			/>

			<div className="mt-8 flex flex-col gap-2">
				<Button
					disabled={status !== "idle"}
					loading={status !== "idle"}
					className="w-full"
					submit
					type="dark"
				>
					{t("buttons.save")}
				</Button>
			</div>
			{/* <pre>{JSON.stringify({ user }, null, 4)}</pre> */}
		</form>
	);
};

EditUserModal.locale = {
	nl: {
		"not-found": {
			title: "Geen gebruiker gevonden",
		},
		fields: {
			team: {
				label: "Team",
			},
		},
		buttons: {
			save: "Opslaan",
			delete: "Verwijderen",
		},
	},
	en: {},
};

export default withTranslation(EditUserModal);
